module.exports = __webpack_public_path__ + "static/media/gabriel.26eecb0d.jpg";